module.exports = __webpack_public_path__ + "static/media/SpectrumAC Statement on Use of Electronic Records.9da95259.pdf";